import React, { useState, useEffect, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Form, Button, Table, Dropdown } from 'react-bootstrap';
import '../../Styles/yellocalfcss/YearlyIncomeReport.css';
import { simplePostCall } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import { formatNumber } from '../../utils/formatNumber';

function YearlyIncomeReport() {
    const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
    const [startDate, setStartDate] = useState('2026-01-27');
    const [endDate, setEndDate] = useState('2026-02-02');
    const [loading, setLoading] = useState(false);

    // State for API Data
    const [reportData, setReportData] = useState({
        expected: [],
        collected: [],
        pending: []
    });

    const fetchInitialData = useCallback(async () => {
        setLoading(true);
        try {
            const payload = {
                      customer_id: Number(localStorage.getItem("customer_id")),
          api_key: localStorage.getItem("api_key"),
                language: "en",
                user_id:localStorage.getItem("user_id"),
                start_date: startDate,
                end_date: endDate
            };

            const response = await simplePostCall(ApiConfig.YearlyIncomeSummaryReport, JSON.stringify(payload));

            if (response && response.result) {
                // Mapping API response to table format
                setReportData({
                    expected: [
                        { category: 'Fee', amount: response.expected_income_fee[0]?.sum || 0 },
                        { category: 'Cashless Summary', amount: response.cashless_summary[0]?.sum || 0 }
                    ],
                    collected: [
                        { category: 'Fee', amount: response.collected_income_fee[0]?.sum || 0 }
                    ],
                    pending: [
                        { category: 'Fee', amount: response.pendup_income_fee[0]?.sum || 0 }
                    ]
                });
            }
        } catch (error) {
            console.error("Error fetching report:", error);
        } finally {
            setLoading(false);
        }
    }, [startDate, endDate]);

    useEffect(() => {
        fetchInitialData();
    }, []); // Runs once on mount

    const handleSearch = () => {
        fetchInitialData(); // Fetch data based on selected dates instead of reloading page
    };

    const handleExport = (selectedOption) => {
        console.log('Export option selected:', selectedOption);
    };

    return (
        <Container fluid className="report-container">
            <div className="report-header-section">
                <Row className="report-header-row">
                    <Col md={8}>
                        <h2 className="report-title">Yearly Income Summary Report</h2>
                    </Col>
                    {/* <Col md={4} className="exports-btn-container text-end">
                        <Dropdown>
                            <Dropdown.Toggle variant="warning" id="dropdown-basic" className="exports-btn">
                                Export
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleExport('Save as PDF')}>Save as PDF</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col> */}
                </Row>
            </div>
           <div className='bg-white rounded p-2'>
          <Row className="yearly-income-report-date-row my-4">
  <Col md={4}>
    <Form.Group>
      <Form.Label>Start Date</Form.Label>
      <Form.Control
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        className="yearly-income-report-input"
      />
    </Form.Group>
  </Col>

  <Col md={4}>
    <Form.Group>
      <Form.Label>End Date</Form.Label>
      <Form.Control
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        className="yearly-income-report-input"
      />
    </Form.Group>
  </Col>

  <Col md={4} className="d-flex align-items-end">
    <Button
      className="yearly-income-report-search-btn"
      onClick={handleSearch}
      disabled={loading}
    >
      {loading ? "Loading..." : "Search"}
    </Button>
  </Col>
</Row>

<div className="yearly-income-report-sections">

  {/* Expected Income */}
  <div className="yearly-income-report-box">
    <div className="yearly-income-report-box-title">Expected Income</div>
    <Table className="yearly-income-report-grid-table">
      <thead>
        <tr>
          <th>Category</th>
          <th className="text-st">Amount</th>
        </tr>
      </thead>
      <tbody>
        {reportData.expected.map((item, i) => (
          <tr key={i}>
            <td>{item.category}</td>
            <td className="text-st">{customer_currency} {formatNumber(item.amount)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>

  {/* Collected Income */}
  <div className="yearly-income-report-box">
    <div className="yearly-income-report-box-title">Collected Income</div>
    <Table className="yearly-income-report-grid-table">
      <thead>
        <tr>
          <th>Category</th>
          <th className="text-st">Amount</th>
        </tr>
      </thead>
      <tbody>
        {reportData.collected.map((item, i) => (
          <tr key={i}>
            <td>{item.category}</td>
            <td className="text-st">{customer_currency} {formatNumber(item.amount)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>

  {/* Pending Income */}
  <div className="yearly-income-report-box">
    <div className="yearly-income-report-box-title">
      Pending / Upcoming Income
    </div>
    <Table className="yearly-income-report-grid-table">
      <thead>
        <tr>
          <th>Category</th>
          <th className="text-st">Amount</th>
        </tr>
      </thead>
      <tbody>
        {reportData.pending.map((item, i) => (
          <tr key={i}>
            <td>{item.category}</td>
            <td className="text-st">{customer_currency} {formatNumber(item.amount)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>

</div>

            </div>
        </Container>
    );
}

export default YearlyIncomeReport;